export const ui: Record<string, string> = {
	ui_abandonGameDialogContent: "Tem certeza disso?",
	ui_abandonGameDialogHeader: "Você está prestes a abandonar o seu jogo",
	ui_abandonGameDialogTitle: "Abandonar jogo",
	ui_btnBack: "Voltar",
	ui_btnCancel: "Cancelar",
	ui_btnClassicPreset: "Clássico",
	ui_btnContinue: "Continuar",
	ui_btnKeepPlaying: "Continuar Jogando",
	ui_btnLoadGame: "Carregar Jogo",
	ui_btnMenu: "Menu",
	ui_btnModernPreset: "Moderno",
	ui_btnNewGame: "Novo Jogo",
	ui_btnNewGameExperimental: "Novo Jogo - Experimental",
	ui_btnPlayTutorial: "Jogar Tutorial",
	ui_btnQuit: "Sair",
	ui_btnQuitToDesktop: "Sair para Desktop",
	ui_btnQuitToMenu: "Sair para Menu",
	ui_btnResume: "Continuar",
	ui_btnResetHints: "Mostrar dicas para iniciantes novamente",
	ui_btnSave: "Salvar",
	ui_btnSettings: "Configurações",
	ui_btnTutorial: "Tutorial",
	ui_characterSelectTitle: "Escolha seu personagem",
	ui_characterSelectSubtitle: "Os personagens diferem apenas no equipamento inicial",
	ui_checkBoxMovementAnimations: "Movimentos animados",
	ui_checkBoxSkipTutorial: "Pular tutorial",
	ui_checkBoxSoundEffects: "Efeitos de som",
	ui_confirmLoseGame: "Seu jogo atual será perdido. Tem certeza?",
	ui_gameOverLabel: "GAME OVER",
	ui_labelAnimationSpeed: "Velocidade de Animação",
	ui_btnCopySeed: "Copiar",
	ui_labelCameraFollowPlayer: "Câmera Segue o Jogador",
	ui_labelCopied: "Copiado!",
	ui_labelAnimationSpeedFactor: "Fator de velocidade nas animações:",
	ui_labelGraphics: "Gráficos:",
	ui_labelGold: "Grana:",
	ui_labelHealth: "Vida:",
	ui_labelHintsReset: "Dicas resetadas",
	ui_lockedLabel: "BLOQUEADO",
	ui_labelInventory: "Itens",
	ui_labelLanguage: "Idioma:",
	ui_labelPaused: "Pausado",
	ui_labelPresets: "Pré-definições:",
	ui_labelSavesNotImplementedYet: "(jogos salvos ainda não foram implementados)",
	ui_labelSettings: "Configurações",
	ui_labelSoundEffects: "Efeitos de Som",
	ui_labelSoundVolume: "Volume do Som",
	ui_labelMusic: "Música",
	ui_labelMusicVolume: "Volume da Música",
	ui_labelTelemetry: "Compartilhar estatísticas anônimas de jogo",
	ui_telemetryNote:
		"Apenas estatísticas anônimas. Nenhum dado pessoal. O IP é usado brevemente para identificar o país e proteger contra abusos, e nunca é armazenado.",
	ui_labelVictory: "VITÓRIA!",
	ui_labelVictoryMessage: "Parabéns, você venceu!\n\nEsperamos que tenha gostado do jogo. \nEsta é uma versão beta que ainda está em desenvolvimento. \n\nSe tiver alguma sugestão ou ideia, envie para o desenvolvedor.",
	ui_labelVolume: "Volume:",
	ui_labelWeapons: "Armas:",
	ui_loadingLabel: "Carregando",
	ui_recharging: "Recarregando ($1)",
	ui_radioButtonEnglish: "English",
	ui_radioButtonPortuguese: "Português",
	ui_savedGameFound: "Jogo salvo encontrado",
	ui_advancedLabel: "Avançado",
	ui_seedPlaceholder: "Semente (opcional)",
	ui_youalsosee: "Você também vê:",
	ui_vendBuyTab: "Comprar",
	ui_vendSellTab: "Vender",
	ui_vendConfirmSale: "Confirmar Venda",
	ui_vendSoldOut: "ESGOTADO",
	ui_vendNoOffers: "Nenhum item à venda.",
	ui_vendNothingToSell: "Nada para vender.",
	ui_vendEach: "cada",
	ui_vendPackSuffix: "(pacote de {n})",
	ui_vendGoldLabel: "Dinheiro: ",
	ui_vendLeft: "restantes",
	ui_vendReceiveTotal: "Você receberá: ",
	ui_yousee: "Voce vê:",
	ui_itemUse: "USAR",
	ui_itemEnable: "ATIVAR",
	ui_itemDisable: "DESATIVAR",
	ui_itemStateOn: "LIGADO",
	ui_itemStateOff: "DESLIGADO",
};
